import { render, staticRenderFns } from "./createNewUser.vue?vue&type=template&id=11a6980f&scoped=true"
import script from "./createNewUser.vue?vue&type=script&lang=ts"
export * from "./createNewUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a6980f",
  null
  
)

export default component.exports